import { render, staticRenderFns } from "./TransactionCard.vue?vue&type=template&id=28edd49a&scoped=true"
import script from "./TransactionCard.vue?vue&type=script&lang=js"
export * from "./TransactionCard.vue?vue&type=script&lang=js"
import style0 from "./TransactionCard.vue?vue&type=style&index=0&id=28edd49a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28edd49a",
  null
  
)

export default component.exports